// 未上线 phase 排序
export const NOT_RELEASE_YET_PHASE_ORDER = [
  'Alpha',
  'Beta',
  'Early Access',
  'Full Release',
  'Released',
  'Cancelled',
  'Offline',
];

// 已上线 phase 排序
export const RELEASED_PHASE_ORDER = ['Alpha', 'Beta', 'Early Access', 'Full Release', 'Released'];

// 已下线 phase 排序
export const OFFLINE_PHASE_ORDER = [
  'Alpha',
  'Beta',
  'Early Access',
  'Full Release',
  'Released',
  'Offline',
];

// 不同阶段 phase 排序的 map 对象
export const PHASE_ORDER_MAP = {
  not_release: NOT_RELEASE_YET_PHASE_ORDER,
  released: RELEASED_PHASE_ORDER,
  offline: OFFLINE_PHASE_ORDER,
};

export const FIXED_SHOW_PLATFORM_LIST = [
  'PC (Microsoft Windows)',
  'PlayStation 4',
  'Xbox One',
  'PlayStation 5',
  'Xbox Series X|S',
  'Nintendo Switch',
];

export const BACKUP_SHOW_PLATFORM_LIST = ['PlayStation 3', 'Xbox 360'];

export const HIDE_PLATFORM_LIST = ['Android', 'iOS'];

export const PLATFORM_ORDER = [
  'Android',
  'iOS',
  'Google Stadia',
  'Linux',
  'Mac',
  'Nintendo Switch',
  'Xbox Series X|S',
  'PlayStation 5',
  'Xbox One',
  'PlayStation 4',
  'PC (Microsoft Windows)',
];
